import type { Row } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';

import { ReactComponent as PlaceholderChecklistsIcon } from '@cobliteam/ui-business/icons/placeholder/placeholder-checklists.svg';

import { TableCell, TableRow } from '@cobliteam/ui/components/Table';
import Typography from '@cobliteam/ui/components/Typography';

interface DataTablePlaceholderProps<TData, TValue> {
  columnsDef: ColumnDef<TData, TValue>[];
  isLoading: boolean;
  isFetching: boolean;
  rows: Row<TData>[];
  placeholder?: React.ReactNode;
}

const DataTableEmptyState = <TData, TValue>({ columnsDef, isLoading, isFetching, rows, placeholder }: DataTablePlaceholderProps<TData, TValue>) => {
  if (isFetching || isLoading) return null;
  if (!isLoading && rows.length > 0) return null;
  if (rows.length) return null;
  return (
    <TableRow hover={false}>
      <TableCell colSpan={columnsDef.length} className='h-80 w-full'>
        <div className='flex flex-col items-center justify-between gap-2 text-center'>
          {placeholder ? (
            placeholder
          ) : (
            <>
              <PlaceholderChecklistsIcon className='h-10 w-10' />
              <Typography color='secondary'>Nenhum resultado encontrado.</Typography>
              <Typography color='secondary'>Ajuste os filtros ou faça uma nova busca.</Typography>
            </>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default DataTableEmptyState;
